import { useMemo } from 'react';

const useShrunkLayout = ({
  widthSize,
  current,
  THRESHOLD,
}) => {
  const shrunkLayout = useMemo(() => {
    if (current) {
      const clientRect = current.getBoundingClientRect();

      return clientRect.width < THRESHOLD;
    }
    return false;
  }, [widthSize, current]);

  return shrunkLayout;
};

export default useShrunkLayout;
